import React from "react";
import { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import GroupsIcon from "@mui/icons-material/Groups";
import MuiAlert from "@mui/material/Alert";
import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Select,
  FormControl,
} from "@mui/material";
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import Tooltip from '@mui/material/Tooltip';
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BudgetError from "./BudgetError";
import ScheduleError1 from "./ScheduleError1";
import CustomDaypicker from "./CustomDaypicker";
import DatePicker from "react-multi-date-picker";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ScheduleError from "./ScheduleError";
import ScheduleError_enddate from "./ScheduleError_enddate";
import ScheduleError_enddatetime from "./ScheduleError_enddatetime";
import ScheduleError_currentime from "./ScheduleError_currentime";
import ScheduleError_doesnotmatch from "./ScheduleError_doesnotmatch";
import CircularProgress from '@mui/material/CircularProgress';
import { calculateScheduleFrequency } from '../../../utils/scheduleUtils';
// import Backdrop from '@mui/material/Backdrop';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0)", // Semi-transparent white background
            backdropFilter: "blur(1px)", // Apply blur effect
            zIndex: 10, // Ensure loader is on top
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box sx={{ opacity: loading ? 0.5 : 1, transition: "opacity 0.3s" }}>
        {children}
      </Box>
    </Box>
  );
};

const Days = [
  { id: 0, name: "Sunday", value: "SUN" },
  { id: 1, name: "Monday", value: "MON" },
  { id: 2, name: "Tuesday", value: "TUE" },
  { id: 3, name: "Wednesday", value: "WED" },
  { id: 4, name: "Thursday", value: "THU" },
  { id: 5, name: "Friday", value: "FRI" },
  { id: 6, name: "Saturday", value: "SAT" },
];

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function a11yProps(value) {
  if (!value) {
    return {
      disabled: true,
      style: { backgroundColor: "#ececec" },
    };
  }
}

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <CalendarTodayIcon onClick={openCalendar} />
    </div>
  )
}

export default function FormDialog(props) {
  const { InstanceID, budget, count } = props;

  const [temporary, settemporary] = React.useState({
    repeat_frequency: "none",
  });

  const [loading, setLoading] = useState(false);

  const [state, setState] = React.useState({
    name: "",
    number_of_trainee: "",
    start_date_time: "",
    end_date_time: "",
    repeat_frequency: "none",
    budget: "",
    budgetStorageHours: 0
  });

  const [budgethours, setBudgetHours] = useState(0);
  const [billingtype, setBillingType] = useState("budgetbased");
  const [error, setError] = useState(""); // Error message state

  const [total_hours, setTotalHours] = React.useState(0);
  const [scheduleError, setScheduleError] = React.useState("");

  const [checkDeploystate, setCheckDeploystate] = React.useState({
    selectedDeployValue: "checkedA",
  });

  const [lablist, setlablist] = React.useState([]);

  // Function to filter available days based on selected end_date_time
  const getAvailableDays = (startDate, endDate) => {
    if (!startDate || !endDate) return [];
  
    // Parse to local date objects
    const startLocal = new Date(startDate);
    const endLocal = new Date(endDate);
  
    if (startLocal > endLocal) return [];
  
    const daySet = new Set();
  
    // Loop from start to end
    const current = new Date(startLocal);
    while (current <= endLocal) {
      // Convert local time to UTC equivalent
      const utcDate = new Date(
        Date.UTC(
          current.getFullYear(),
          current.getMonth(),
          current.getDate(),
          current.getHours(),
          current.getMinutes(),
          current.getSeconds()
        )
      );
  
      const dayIndex = utcDate.getUTCDay(); // Get day index in UTC (0 = Sunday, ..., 6 = Saturday)
      daySet.add(dayIndex);
  
      // Move to next day in local time
      current.setDate(current.getDate() + 1);
    }
  
    // Assuming Days is:
    // const Days = [{ id: 0, name: 'Sunday' }, ..., { id: 6, name: 'Saturday' }];
    return Days.filter((day) => daySet.has(day.id));
  };

  // React.useEffect(() => {
  //   fetch(`${process.env.REACT_APP_API_URL}/api/sharedvmlablist/`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //   })
  //     .then((resp) => resp.json())
  //     .then((data) => {
  //       if (data.detail) {
  //       } else {
  //         setlablist(data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // }, []);

  useEffect(() => {
    let isMounted = true; // Flag to track if component is still mounted

    fetch(`${process.env.REACT_APP_API_URL}/api/sharedvmlablist/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (isMounted) {
          if (!data.detail) {
            setlablist(data); // Only update state if component is still mounted
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      isMounted = false; // Cleanup function to prevent state updates
    };
  }, []);

  const handlecheckDeployChange = (event) => {
    const name = "selectedDeployValue";
    const id = "billingtype";
    setCheckDeploystate({ [name]: event.target.value });
    if (event.target.value === "checkedA") {
      setBillingType("budgetbased");
    } else if (event.target.value === "checkedB") {
      setBillingType("hourlybased");
    }
  };

  const [frequencyday, setFrequencyDay] = React.useState([]);
  const [numberfind, setnumberfind] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const [frequencyMonth, setFrequencyMonth] = useState();

  const [scheduleerroropen1, setscheduleerroropen1] = React.useState(false);
  const [scheduleerroropen, setscheduleerroropen] = React.useState(false);
  const [scheduleerroropen2, setscheduleerroropen2] = React.useState(false);
  const [scheduleerroropen3, setscheduleerroropen3] = React.useState(false);
  const [scheduleerroropen4, setscheduleerroropen4] = React.useState(false);
  const [scheduleerroropen5, setscheduleerroropen5] = React.useState(false);
  const [responseepochTime, setResponseEpochTime] = useState();
  const [find, setfind] = useState(false);
  const [ShowNoofTraineeAlert, setShowNoofTraineeAlert] = useState(false);

  useEffect(() => {
    let isMounted = true; // Track component mount status

    fetch(`${process.env.REACT_APP_API_URL}/api/getcurrentdatetime/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (isMounted) {
          setResponseEpochTime(data); // Update state only if component is mounted
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      isMounted = false; // Cleanup function: prevents state updates after unmounting
    };
  }, []);

  const MILLISECONDS_PER_HOUR = 1000 * 60 * 60;

  const MILLISECONDS_PER_MINUTE = 60 * 1000;

  const getFormattedCurrentDateTime = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  };

  const handleChange = (e) => {
    setfind(false);

    const { id, value } = e.target;
    const selectedDate = new Date(value);

    const currentDateTime = new Date();
    const epochTimeInGMT = (currentDateTime.getTime() + (currentDateTime.getTimezoneOffset() * 60 * 1000));
    const db_epochtime = responseepochTime * 1000;
    const timeDifference = Math.abs(epochTimeInGMT - db_epochtime);
    const final_time_difference = timeDifference / (60 * 1000);
    setBudgetHours(0);

    const serverEpochTimeMs = responseepochTime * 1000;
    if (responseepochTime && selectedDate < serverEpochTimeMs) {
      setError("You cannot select a past date and time.");
      setState((prev) => ({
        ...prev,
        [id]: "", // Clear invalid date
      }));
      return;
    }

    if (id === "end_date_time") {
      const startDate = new Date(state.start_date_time);
      const endDate = selectedDate;

      if (state.start_date_time) {
        // Ensure End Date is not the same as Start Date
        if (startDate.getTime() === endDate.getTime()) {
          setError("You selected the same time for Start and End.");
        } else if (endDate < startDate) {
          setError("End Date & Time must be after Start Date & Time.");
        } else {
          setError("");
        }
      }
    }

    if (id === "start_date_time" || id === "end_date_time") {
      setTotalHours(0);
      const start = id === "start_date_time" ? value : (state.start_date_time || getFormattedCurrentDateTime());
      // console.log("start", start);
      const end = id === "end_date_time" ? value : state.end_date_time;
      // console.log("end", end);

      if (start && end) {
        const date1 = new Date(start);
        // console.log("date1", date1);
        const date2 = new Date(end);
        // console.log("date2", date2);
        const timeDiff = Math.abs(date2 - date1);
        // console.log("timeDiff", timeDiff);
        const diffHours = Math.round(timeDiff / MILLISECONDS_PER_HOUR);

        const diffMinutes = timeDiff / MILLISECONDS_PER_MINUTE;
        const roundedDiffMinutes = Math.round(diffMinutes);
        // const diffMinutes = diffHours * 60;

        // console.log("diffHours", diffHours);

        setTotalHours(diffHours);

        setState((prevState) => ({
          ...prevState,
          budgetStorageHours: roundedDiffMinutes,
        }));
      }
    }

    if (final_time_difference > 600) {
      setscheduleerroropen5(true)
    }
    else {

      if (schedulecheckstate.selectedValue !== "checkedB") {
        setState((prevState) => ({
          ...prevState,
          [id]: value,
          repeat_frequency: prevState.repeat_frequency !== undefined ? "none" : prevState.repeat_frequency,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          [id]: value,
        }));
      }
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));

    }
  };

  const handleNoOfTranieeChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    if (value % 4 === 0) {
      setShowNoofTraineeAlert(false);
      setState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
    else {
      setShowNoofTraineeAlert(true);
    }
  };

  const handleLabNameChange = (e) => {
    // e.preventDefault();  // Remove this line
    const { id, value } = e.target;
    // console.log("Typed value: ", value); // Log input value

    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));

    setfind(false);

    // Check if the lab name already exists
    const exists = lablist.some((instance) => instance.name === value);
    setfind(exists);
  };


  const handleBudgetChange = (e) => {
    const { id, value } = e.target;
    setnumberfind(false);

    const inputValue = e.target.value;

    // Ensure the value is a positive integer
    if (/^[0-9]*$/.test(inputValue)) {
      const numericValue = parseInt(inputValue, 10);
      if (numericValue <= 0) {
        setnumberfind(true);
      }else{
        setState((prevState) => ({
          ...prevState,
          [id]: value,
        }));
        settemporary((prevState) => ({
          ...prevState,
          [id]: value,
        }));
        // setBudgetValue(value);
      }
    }
    else{
      // Input contains invalid characters (non-numeric)
      setnumberfind(true);
    }
  };

  const handleHourlybasedChange = (e) => {
    const { id, value } = e.target;
    const hours = parseInt(value, 10);

    if (hours > total_hours) {
      setScheduleError("Please enter the appropriate hours");
    } else {
      setScheduleError("");
    }
    setBudgetHours(value);
  }

  useEffect(() => {
    setBudgetHours(0);

  }, [billingtype]);

  const [schedulecheckstate, setSchedulecheckstate] = React.useState({
    selectedValue: "checkedA",
  });

  const handleChange1 = (event, value) => {
    const id = "cronvalue";
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const [budgetopen, setBudgetOpen] = React.useState(false);

  const handleschedulecheckChange = (event) => {
    const name = "selectedValue";
    setSchedulecheckstate({ [name]: event.target.value });
  };

  const [checkstate, setCheckstate] = React.useState({
    selectedValue: "",
  });

  // const [feedbackState, setFeedbackState] = React.useState(false);

  const [feedbackState, setFeedbackState] = React.useState({});
  const [fbState, setFbState] = React.useState({});

  const [selectedDates, setSelectedDates] = React.useState([]);
  const [fbmaxDate, setFbMaxDate] = useState([]);
  const [fbCount, setFbCount] = useState([]);

  function handleDateChange(date) {
    const { feedbackno } = temporary;
    const formattedDates = date.map((d) => d.format("DD/MM/YYYY"));
    const selectedDatesCount = (formattedDates.length).toString();

    setSelectedDates(formattedDates);
    setFbCount(selectedDatesCount);
  }

  // console.log(selectedDates);
  // console.log(fbCount);

  const handlecheckChange = (event) => {
    setCheckstate({ ...checkstate, [event.target.name]: event.target.checked });
  };

  // console.log(checkstate);

  const handlecheckFeedbackChange = (event) => {
    const name = "feedbackCheckboxValue";
    const id = "feedbackState";
    setFeedbackState({ ...feedbackState, [event.target.name]: event.target.checked });
    setFbState(event.target.checked ? "Yes" : "No");
  };
  // console.log(feedbackState);
  // console.log(fbState);

  const [mailId, setMailId] = React.useState([]);
  const [emailError, setEmailError] = useState('');

  const [meetingLink, setMeetingLink] = React.useState([]);
  const [startWithHyphen, setStartWithHyphen] = useState(false);

  const handleMeetingLinkChange = (e) => {
    const linkURL = e.target.value;
    setMeetingLink(linkURL);
  }

  const handleMailChange = (e) => {
    const { id, value } = e.target;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (id === 'email' && !emailRegex.test(value)) {
      setEmailError('Please enter the email in correct format');
      settemporary((prevState) => ({
        ...prevState,
        [id]: "",
      }));
    } else {
      setEmailError('');
      setMailId(e.target.value);
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  // console.log(mailId);



  const [keepLabDate, setKeepLabDate] = React.useState([]);

  const handleKeepLabChange = (e) => {
    const { id, value } = e.target;
    setKeepLabDate((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  // console.log(keepLabDate);

  const [keepLab, setKeepLab] = React.useState([]);
  const handlecheckBudgetChange = (event) => {
    setKeepLab((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
  };

  const handlecheckRelatedLabChange = (event) => {
    const { name, checked } = event.target;

    setSelectedRelatedLabType('');
    setselectedMasterLabId('');

    settemporary((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    setState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    // console.log("checked----->", temporary.guacmoleLabState)
  };
  // console.log(keepLab);


  useEffect(() => {
    const id = "env_keep_date"
    setKeepLabDate('');
    settemporary((prevState) => ({
      ...prevState,
      [id]: [],
    }));
  }, [keepLab]);

  useEffect(() => {
    setSelectedDates([]);
  }, [feedbackState]);

  const [bothChecked, setBothChecked] = React.useState(false);
  const [bothValue, setBothValue] = React.useState(false);

  const [manageState, setManageState] = React.useState('');
  const [manageLabState, setManageLabState] = React.useState('no');

  const handlecheckManageLabChange = (event) => {
    const name = "manageCheckboxValue";
    const id = "manageState";
    setManageState({ ...manageState, [event.target.name]: event.target.checked });
    setManageLabState(event.target.checked ? "yes" : "no");
  };

  useEffect(() => {
    if (checkstate.checkedB && feedbackState.feedbackCheckbox) {
      setBothChecked(true);
      if (temporary.email && selectedDates.length) {
        setBothValue(true);
      } else {
        setBothValue(false);
      }
    } else {
      setBothChecked(false);
      setBothValue(false);
    }
  }, [checkstate.checkedB, feedbackState.feedbackCheckbox, temporary.email, selectedDates]);
  // console.log(bothChecked);
  // console.log(bothValue);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      start_date_time: "",
    }));
    settemporary((prevState) => ({
      ...prevState,
      start_date_time: "",
    }));

    setState((prevState) => ({
      ...prevState,
      end_date_time: "",
    }));
    settemporary((prevState) => ({
      ...prevState,
      end_date_time: "",
    }));

    setState((prevState) => ({
      ...prevState,
      repeat_frequency: "none",
    }));
    settemporary((prevState) => ({
      ...prevState,
      repeat_frequency: "none",
    }));
    setTotalHours(0);
    setScheduleError("");

  }, [schedulecheckstate.selectedValue]);

  const [masterValue, setMasterValue] = useState('');
  // const [masterOrRelatedValue, setMasterOrRelatedValue] = useState('');

  const [otherlablist, setOtherLabList] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [masterOrRelatedLab, setMasterOrRelatedLab] = useState('');
  const [labtypeoptionslist, setLabTypeOptionsList] = useState([
    { id: 'preconfig', value: 'Preconfigured' },
    { id: 'custom', value: 'Custom' },
    { id: 'hypervised', value: 'Hypervised' },
    { id: 'shared', value: 'Shared' },
    { id: 'wise', value: 'Wise' },
    // { id: 'cloud', value: 'Cloud' },
    { id: 'manual', value: 'Manual' },
  ]);
  // State for the selected lab type
  const [selectedRelatedLabType, setSelectedRelatedLabType] = useState('');
  const [selectedMasterLabId, setselectedMasterLabId] = useState('');
  const [traineeCount, setTraineeCount] = useState(0);

  const getTenDaysAfterEndDate = (endDate) => {
    if (!endDate) {
      return "";
    }
    const date = new Date(endDate);
    date.setDate(date.getDate() + 10); // Adds 10 days to the end date
  
    // Format the date to "YYYY-MM-DD"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`;
  };

  // Handle change of first dropdown (lab type)
  const handleLabTypeChange = (event) => {
    setselectedMasterLabId('');
    setSelectedRelatedLabType(event.target.value);
    // console.log("value", event.target.value)
    // console.log("selectedRelatedLabType", selectedRelatedLabType)
    const { name, value } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    let labListName = ""
    setOtherLabList([]);
    if (event.target.value === "preconfig") {
      // console.log("step-1---", event.target.value);
      labListName = "preconfiguredlablist"
    }
    else if (event.target.value === "custom") {
      // console.log("step-2---", event.target.value);
      labListName = "customlablist"
    }
    else if (event.target.value === "hypervised") {
      // console.log("step-3---", event.target.value);
      labListName = "hypervisedlablist"
    }
    else if (event.target.value === "shared") {
      // console.log("step-4---", event.target.value);
      labListName = "sharedvmlabslist"
    }
    else if (event.target.value === "wise") {
      // console.log("step-5---", event.target.value);
      labListName = "wiselabslist"
    }
    // else if (event.target.value === "cloud") {
    //   // console.log("step-6---", event.target.value);
    //   labListName = "cloudlabslist"
    // }
    else if (event.target.value === "manual") {
      // console.log("step-7---", event.target.value);
      labListName = "manuallabslist"
    }
    if (labListName !== "") {
      let org_id = "org_0001"
      fetch(`${process.env.REACT_APP_API_URL}/api/${labListName}/${org_id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          // console.log("----------data information-------", data);
          setDialogOpen(false);
          setOtherLabList(data)
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  // const handleMasterOrRelatedLabChange = (event) => {
  //   const { name, value } = event.target;
  //   setState((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  //   settemporary((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  //   if (name === "selectedMasterOrRelatedLab") {
  //     setMasterOrRelatedLab(event.target.value);
  //   }
  //   // if (name === "selectedRelatedLab") {
  //   //   setMasterValue(event.target.value);
  //   // }
  // };

  // Handle changes in the second dropdown
  const handleMasterLabNameChange = (event) => {
    setselectedMasterLabId('');
    const selectedLabId = event.target.value;
    setselectedMasterLabId(selectedLabId);
    const { name, value } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Find the selected lab from the lablist
    const selectedLab = otherlablist.find((lab) => lab.id === parseInt(selectedLabId));

    if (selectedLab) {
      setTraineeCount(selectedLab.traineeCount); // Update the traineeCount state
    }

    if (parseInt(state.number_of_trainee) === parseInt(selectedLab.traineeCount)) {

      setDialogOpen(false);
    } else {
      setselectedMasterLabId('');
      setDialogOpen(true);
    }
  };

  // useEffect(() => {
  //   setMasterValue('');
  //   let name = "selectedMasterLab";
  //   settemporary((prevState) => ({
  //     ...prevState,
  //     [name]: '',
  //   }));
  // }, [masterOrRelatedValue]);

   useEffect(() => {
    setMasterValue('');
    setMasterOrRelatedLab('');
    // const name = "selectedMasterOrRelatedLab";
    // setState((prevState) => ({
    //   ...prevState,
    //   [name]: "",
    // }));
    // settemporary((prevState) => ({
    //   ...prevState,
    //   [name]: "",
    // }));

  }, [temporary.guacmoleLabState, otherlablist]);

  const handleSubmitClick = (labid) => async (e) => {
    setLoading(true);
    e.preventDefault();
    let budgetState = false;
    let hourlyBasedAmount = 0;
    // console.log("Testing frontend ------------>")
    // console.log("check-1", checkDeploystate.selectedDeployValue);

    let available = localStorage.getItem("available");
    if (checkDeploystate.selectedDeployValue !== "checkedB") {
      if (parseInt(state.budget) > parseInt(available)) {
        setBudgetOpen(true);
        setLoading(false);
        budgetState = true;
      }
    } else {
      setBudgetOpen(false);
      budgetState = false;
    }

    if (checkDeploystate.selectedDeployValue === "checkedB") {
      var startDate;
      var endDate;

      if (state.start_date_time) {
        startDate = new Date(state.start_date_time);
          // .toISOString()
          // .split("T")[0];

      } else {
        startDate = new Date();
      }

      if (state.end_date_time) {
        endDate = new Date(state.end_date_time);
          // .toISOString()
          // .split("T")[0];
      } else {
        endDate = new Date();
      }

      var addvalue = {
        labtype: "sharedvm",
        nooftrainee: state.number_of_trainee,
        budgethours: budgethours,
        start_date: startDate,
        end_date: endDate,
        labid: labid, // Include labid in the request payload
        machine_count: 0
      };

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/clonebudgethourscalculation/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify(addvalue),
        });

        const data = await response.json();
        if (data) {
          // setCalculateAmount(data);
          hourlyBasedAmount = data;

          // console.log("Testing frontend -Sterp-2----------->");

          if (parseInt(hourlyBasedAmount) > parseInt(available)) {
            setBudgetOpen(true);
            setLoading(false);
            budgetState = true;
          } else {
            setBudgetOpen(false);
            budgetState = false;
          }
        } else {
          console.log("Error: No data received");
        }
      } catch (error) {
        console.error("Error fetching budget hours calculation:", error);
      }
    }

    if (!budgetState) {
      if (checkDeploystate.selectedDeployValue === "checkedA" || checkDeploystate.selectedDeployValue === "checkedB") {
        // console.log("selected value", schedulecheckstate.selectedValue);

        var env_keep;
        if (keepLab.env_keep === true) {
          env_keep = "yes";
        } else {
          env_keep = "no";
        }

        var disableCopyPasteState;
        if (keepLab.disable_copypaste === true) {
          disableCopyPasteState = "yes";
        } else {
          disableCopyPasteState = "no";
        }

        var identicalPasswordServer;
        if (keepLab.identicalpassword === true) {
          identicalPasswordServer = "yes";
        } else {
          identicalPasswordServer = "no";
        }

        // var guacmoleLab;
        // if (keepLab.guacmoleLabState) {
        //   guacmoleLab = "yes";
        // } else {
        //   guacmoleLab = "no";
        // }

        let timecount = 0;
        let timecount1 = 0;
        let err_enddatebeforethedate = 0
        let err_enddatebeforethedateandtime = 0
        let err_currenandlocaltime = 0

        var cron_expression_for_start;
        var cron_expression_for_end;
        var cron_expression_for_start2;
        var cron_expression_for_end2;
        var depends_on;

        var startDate;
        var endDate;
        // var NewstartDate;
        // var stDate1;

        var FinalstartTime;
        var FinalstopTime;
        var dummy_repeatFrequency;

        const repeatFrequency = state.repeat_frequency;
        const Every = state.every;

        if (state.start_date_time) {
          startDate = new Date(state.start_date_time).toISOString().split("T")[0];

        } else {
          startDate = new Date().toISOString().substring(0, 10);
        }

        if (state.end_date_time) {
          endDate = new Date(state.end_date_time).toISOString().split("T")[0];
        } else {
          endDate = new Date().toISOString().substring(0, 10);
        }

        const utcEndDateTime = new Date(state.end_date_time).toISOString();
        // Extract time part (HH:MM:SS)
        const timeEndPart = utcEndDateTime.split("T")[1].split(".")[0]; // "06:44:00"
        // Extract hours and minutes
        const utcEndDate = utcEndDateTime.split("T")[0];
        const [endyear, endmonths, enddays] = utcEndDate.split("-");
        const [stophours, stopminutes] = timeEndPart.split(":");

        FinalstopTime = `${stophours}:${stopminutes}`;

        if (schedulecheckstate.selectedValue !== "checkedC") {
          err_currenandlocaltime = 0
          if (err_currenandlocaltime === 0) {
            // console.log('Condition is statisfied Start date with end date');
            // ******** Cron calculation is starting ****************************************************************

            if (state.cronvalue) {
              const onDays = state.cronvalue;

              const MaponDays = onDays
                .sort((a, b) => (a.id > b.id ? 1 : -1))
                .map((ondayvalue) => {
                  const one = ondayvalue.value;
                  return one;
                });
              const stringonDays = JSON.stringify(MaponDays);
              const onDaysreplace = stringonDays
                .replace("[", "")
                .replace("]", "")
                .replace(/"/g, "");
              var NewonDays = onDaysreplace;
              var stronDays = NewonDays;
            }

            // Minutes Hours Days(start-end) Month(start-end) Week  Year(start-end)
            //    30     3        8-9              8-8         ?       2021-2021

            const utcDateTime = new Date(state.start_date_time).toISOString();
            // Extract time part (HH:MM:SS)
            const timePart = utcDateTime.split("T")[1].split(".")[0]; // "06:44:00"
            // Extract hours and minutes
            const utcDate = utcDateTime.split("T")[0];
            const [year, startmonths, startdays] = utcDate.split("-");

            const [starthours, startminutes] = timePart.split(":");

            FinalstartTime = `${starthours}:${startminutes}`;

            if (schedulecheckstate.selectedValue === "checkedA") {
              depends_on = "always";
              cron_expression_for_start = `${startminutes} ${starthours} ${startdays} ${startmonths} ?`;
              cron_expression_for_end = `${stopminutes} ${stophours} ${enddays} ${endmonths} ?`;
              // console.log("cron_expression_for_start", cron_expression_for_start);
              // console.log("cron_expression_for_end", cron_expression_for_end);
              dummy_repeatFrequency = "none";
            }
            else if (schedulecheckstate.selectedValue === "checkedB") {
              depends_on = "during_training";
              dummy_repeatFrequency = repeatFrequency;
              if (repeatFrequency === "day") {
                if (frequencyday.length === 0) {
                  timecount1 = timecount1 + 1;
                }
                else {
                  let freq = 1;
                  const updat_freq_start = calculateScheduleFrequency(state.start_date_time, frequencyday, repeatFrequency, freq);
                  const updat_freq_stop = calculateScheduleFrequency(state.end_date_time, frequencyday, repeatFrequency, freq);
                  cron_expression_for_start = `${startminutes} ${starthours} ${updat_freq_start} ?`;
                  cron_expression_for_end = `${stopminutes} ${stophours} ${updat_freq_stop} ?`;

                  // console.log("frequency -->", frequencyday[0])
                  // cron_expression_for_start = `${startminutes} ${starthours} ${frequencyday[0]} ?`;
                  // cron_expression_for_end = `${stopminutes} ${stophours} ${frequencyday[0]} ?`;
                  // console.log(("cron_expression_for_start", cron_expression_for_start);
                  // console.log(("cron_expression_for_end", cron_expression_for_end);
                  if (frequencyday[1] !== undefined) {
                    freq = 2
                    const updat_freq_start2 = calculateScheduleFrequency(state.start_date_time, frequencyday, repeatFrequency, freq);
                    const updat_freq_stop2 = calculateScheduleFrequency(state.end_date_time, frequencyday, repeatFrequency, freq);
                    cron_expression_for_start2 = `${startminutes} ${starthours} ${updat_freq_start2} ?`;
                    cron_expression_for_end2 = `${stopminutes} ${stophours} ${updat_freq_stop2} ?`;
                    
                    // cron_expression_for_start2 = `${startminutes} ${starthours} ${frequencyday[1]} ?`;
                    // cron_expression_for_end2 = `${stopminutes} ${stophours} ${frequencyday[1]} ?`;
                  } else {
                    cron_expression_for_start2 = 'multiple month not selected';
                    cron_expression_for_end2 = 'multiple month not selected';
                  }
                }
              } else {
                if (stronDays === undefined) {
                  timecount1 = timecount1 + 1;
                }
                else {
                  cron_expression_for_start = `${startminutes} ${starthours} ? ${startmonths} ${NewonDays}`;
                  cron_expression_for_end = `${stopminutes} ${stophours} ? ${startmonths} ${NewonDays}`;
                  if (startmonths != endmonths) {
                    cron_expression_for_start2 = `${startminutes} ${starthours} ? ${endmonths} ${NewonDays}`;
                    cron_expression_for_end2 = `${stopminutes} ${stophours} ? ${endmonths} ${NewonDays}`;
                  } else {
                    cron_expression_for_start2 = 'multiple month not selected';
                    cron_expression_for_end2 = 'multiple month not selected';
                  }
                }
              }
            }

            // ******** Cron calculation is ending *****************
          }
        }
        if (schedulecheckstate.selectedValue === "checkedC") {
          depends_on = "immediate";
          dummy_repeatFrequency = "none";
          err_currenandlocaltime = 0

          const startDate_UTC = new Date().toISOString();
          const timePart = startDate_UTC.split("T")[1].split(".")[0];
          const [starthours, startminutes] = timePart.split(":");
          FinalstartTime = `${starthours}:${startminutes}`;

          if (err_currenandlocaltime === 0) {
            cron_expression_for_end = `${stopminutes} ${stophours} ${enddays} ${endmonths} ?`;
          }
        }

        // console.log("*******************Checking with log***********************************")
        // console.log("startDate", startDate)
        // console.log("endDate", endDate)
        // console.log("FinalstartTime", FinalstartTime)
        // console.log("FinalstopTime", FinalstopTime)
        // console.log("depends_on", depends_on)
        // console.log("repeatFrequency", dummy_repeatFrequency)
        // console.log("Every", Every)
        // console.log("NewonDays", NewonDays)
        // console.log("cron_expression_for_start", cron_expression_for_start)
        // console.log("cron_expression_for_end", cron_expression_for_end)
        // console.log("cron_expression_for_start2", cron_expression_for_start2)
        // console.log("cron_expression_for_end2", cron_expression_for_end2)

        var guacmoleLab;
        var master_or_realated;
        if (temporary.guacmoleLabState) {
          guacmoleLab = "yes";
          master_or_realated = "related"
        } else {
          guacmoleLab = "no";
          master_or_realated = "master"
        }

        if (timecount > 0) {
          setscheduleerroropen(true);
        }
        else if (timecount1 > 0) {
          setscheduleerroropen1(true);
        }
        else if (err_enddatebeforethedate > 0) {
          // console.log("error-2")
          setscheduleerroropen2(true);
        }
        else if (err_enddatebeforethedateandtime > 0) {
          // console.log("error-3")
          setscheduleerroropen3(true);
        }
        else if (err_currenandlocaltime > 0) {
          // console.log("error-4")
          setscheduleerroropen4(true);
        } else {
          const formattedSelectedDates = selectedDates.join(",");
          const data = {
            labid: labid,
            name: state.name,
            number_of_trainee: state.number_of_trainee,
            start_date: startDate,
            end_date: endDate,
            start_time: FinalstartTime,
            stop_time: FinalstopTime,
            depends_on: depends_on,
            repeat_frequency: state.repeat_frequency,
            startcron_expression: cron_expression_for_start,
            stopcron_expression: cron_expression_for_end,
            startcron_expression2: cron_expression_for_start2,
            stopcron_expression2: cron_expression_for_end2,
            budget: state.budget,
            email: mailId,
            feedback: fbState,
            feedback_no: fbCount,
            feedBack_date: formattedSelectedDates,
            manage_labs: manageLabState,
            env_keep: env_keep,
            env_keep_date: keepLabDate,
            budgethours: budgethours,
            billingtype: billingtype,
            disable_copypaste_guac: disableCopyPasteState,
            budgetStorageHours: state.budgetStorageHours,
            meeting_url: meetingLink,
            hourlyBasedAmount: hourlyBasedAmount,
            selectedRelatedLabType: state.selectedRelatedLabType,
            selectedMasterLabId: state.selectedMasterLabId,
            guacmoleLabState: guacmoleLab,
            selectedMasterOrRelatedLab: master_or_realated,
            identicalPassword: identicalPasswordServer,
            // guacmoleLabState: guacmoleLab,
            // selectedMasterOrRelatedLab: masterOrRelatedValue,
            // selectedMasterLab: masterValue,
          };
          console.log(JSON.stringify(data));

          // fetch(`${process.env.REACT_APP_API_URL}/api/svmcloneinstance/`, {
          //   method: "POST",
          //   headers: {
          //     "Content-Type": "application/json",
          //     Authorization: "Bearer " + localStorage.getItem("token"),
          //   },
          //   body: JSON.stringify(data),
          // })
          //   .then((response) => response.json())
          //   .then((data) => {
          //     if (data.name) {
          //       window.location.reload();
          //     } else {
          //       if (data.name) {
          //         setState({ errorMessage: data.name[0] });
          //       }
          //     }
          //   })
          //   .catch((error) => {
          //     window.location.reload();
          //   });
        }
      }
    }
    setLoading(false);
  };


  const [open, setOpen1] = React.useState(false);

  const handleClickOpen = () => {
    setOpen1(true);
  };

  const handleKeyPress = (event) => {
    if (event.key === '_') {
      event.preventDefault();
    }
  };

  const handleClickClose = () => {
    setOpen1(false);

    setMailId('');
    setFbCount('');
    setFeedbackState('');
    setSelectedDates([]);
    setCheckstate('');
    setManageLabState('');
    setSchedulecheckstate({ selectedValue: "checkedA" });
    const id = "name";
    setState((prevState) => ({
      ...prevState,
      [id]: "",
    }));
    const id1 = "number_of_trainee";
    setState((prevState) => ({
      ...prevState,
      [id1]: "",
    }));
    const id2 = "budget";
    setState((prevState) => ({
      ...prevState,
      [id2]: "",
    }));
  };

  var currentTime = new Date();

  var currentOffset = currentTime.getTimezoneOffset();
  var ISTOffset = 330; // IST offset UTC +5:30
  var ISTTime = new Date(
    currentTime.getTime() + (ISTOffset + currentOffset) * 60000
  );
  var hoursIST = ISTTime.getHours();
  var minutesIST = ISTTime.getMinutes();
  var currentDate = new Date().toISOString().substring(0, 10);
  let DateTimeformat = `${currentDate}`;

  let localTime = new Date();
  let minDate1 = moment(localTime).format("YYYY-MM-DDTHH:MM");

  let startTimelocal = new Date(state.start_date_time);
  let startday = (startTimelocal.getDate() + 1).toString().padStart(2, "0");
  let startmonth = (startTimelocal.getMonth() + 1).toString().padStart(2, "0");

  let startyear = startTimelocal.getFullYear();
  let maxDate1 = `${startyear}-${startmonth}-${startday}`;

  let Dateformat = new Date(DateTimeformat);
  let currentDateTime = `${hoursIST}:${minutesIST}`;

  var nextMonth = ((Dateformat.getMonth() + 1) % 12) + 1;
  var cMonth = Dateformat.getMonth() + 1;

  if (cMonth === 12) {
    var year = currentTime.getFullYear() + 1;
    var date = new Date(`${year}`, `${nextMonth}`, 0);
    var endDate = date.getDate();
    var maxDate = `${year}-${nextMonth}-${endDate}`;
  } else {
    var year = currentTime.getFullYear();
    var date = new Date(`${year}`, `${nextMonth}`, 0);
    var endDate = date.getDate();
    var maxDate = `${year}-${nextMonth}-${endDate}`;
  }
  var maxDateFinal = new Date(maxDate).toISOString().substring(0, 10);

  const twoMonthsFromStartDate = (startDate) => {
    if (!startDate) {
      return "";
    }
    const date = new Date(startDate);
    date.setMonth(date.getMonth() + 2); // Adds two months to the date
  
    // Format the date to "YYYY-MM-DDTHH:mm" for the input's max attribute
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const twoMonthsFromCurrentDate = () => {
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + 2); // Adds two months to the current date
  
    // Format the date to "YYYY-MM-DDTHH:mm" for the input's max attribute
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <div>
      <Tooltip title="Clone Lab" arrow>
        <Button onClick={handleClickOpen} color="primary" variant="contained" aria-label="Clone Lab"
          sx={{ borderRadius: '50px', minWidth: 0, width: 36, height: 36, p: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <ContentCopyTwoToneIcon fontSize="small" />
        </Button>
      </Tooltip>
      <Dialog
        fullWidth
        open={open}
        onClose={handleClickClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title"></DialogTitle>
        <BudgetError
          validerroropen={budgetopen}
          deployState={checkDeploystate.selectedDeployValue}
          setvaliderroropen={setBudgetOpen}
        />
        <ScheduleError
          validerroropen={scheduleerroropen}
          setvaliderroropen={setscheduleerroropen}
        />
        <ScheduleError1
          validerroropen={scheduleerroropen1}
          setvaliderroropen={setscheduleerroropen1}
        />
        <ScheduleError_enddate
          validerroropen={scheduleerroropen2}
          setvaliderroropen={setscheduleerroropen2}
        />
        <ScheduleError_enddatetime
          validerroropen={scheduleerroropen3}
          setvaliderroropen={setscheduleerroropen3}
        />
        <ScheduleError_currentime
          validerroropen={scheduleerroropen4}
          setvaliderroropen={setscheduleerroropen4}
        />
        <ScheduleError_doesnotmatch
          validerroropen={scheduleerroropen5}
          setvaliderroropen={setscheduleerroropen5}
        />
        <DialogContent>
          <LoadingOverlay loading={loading}>
            <DialogContentText style={{ textAlign: "center" }}>
              <strong style={{ color: "#000000" }}>Enter Clone Details</strong>
            </DialogContentText>
            <br />
            <br />
            <TextField
              fullWidth
              type="text"
              color={temporary.name && !find && !startWithHyphen ? "success" : ""}
              helperText={
                startWithHyphen
                  ? "Name cannot start with a hyphen"
                  : find
                  ? "Lab name already exists, Please enter a unique name"
                  : "Please specify the name"
              }
              error={find || startWithHyphen}
              label="Name"
              name="name"
              id="name"
              value={state.name}
              size="small"
              onChange={handleLabNameChange}
              // onKeyPress={handleKeyPress}
              required
            />
            <br />
            <br />
            <TextField
              fullWidth
              label="Number of Trainee"
              name="number_of_trainee"
              id="number_of_trainee"
              size="small"
              placeholder={count}
              // color={state.number_of_trainee % 4 === 0 ? "success" : "error"}
              color={!ShowNoofTraineeAlert ? "success" : "error"}
              helperText="Enter number of trainees in multiples of 4"
              InputProps={{
                inputProps: {
                  min: 4,
                },
              }}
              onChange={handleNoOfTranieeChange}
              required
              autoComplete="name"
            />
            <br />
            <br />
            <Box sx={{ pb: 2, pt: 2 }}>
              <Typography variant="h6" gutterBottom>
                Scheduling
              </Typography>
              <Divider />
            </Box>
            <Box
              borderColor="error.main"
              border={schedulecheckstate.selectedValue === "checkedA" ? 1 : 0}
            >
              <Accordion
                square
                expanded={schedulecheckstate.selectedValue === "checkedA"}
              >
                <AccordionSummary>
                  <FormControlLabel
                    aria-label="Acknowledge"
                    control={
                      <Checkbox
                        checked={schedulecheckstate.selectedValue === "checkedA"}
                        onChange={handleschedulecheckChange}
                        value="checkedA"
                        color="secondary"
                      />
                    }
                    label={
                      <Typography variant="h5">
                        {" "}
                        Always{" "}
                        <small>
                          ( Lab will be running continuously between the schedule
                          provided )
                        </small>
                      </Typography>
                    }
                  />
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <Typography variant="h7" gutterBottom>
                        Start Date & Time
                      </Typography>
                      <TextField
                        fullWidth
                        name="start_date_time"
                        id="start_date_time"
                        type="datetime-local"
                        value={state.start_date_time}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        disabled={
                          schedulecheckstate.selectedValue === "checkedA"
                            ? false
                            : true
                        }
                        inputProps={{
                          min: minDate1,
                          max: `${maxDateFinal}T00:00`,
                        }}
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Typography variant="h7" gutterBottom>
                        End Date & Time
                      </Typography>
                      <TextField
                        fullWidth
                        name="end_date_time"
                        id="end_date_time"
                        type="datetime-local"
                        value={state.end_date_time}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        disabled={
                          schedulecheckstate.selectedValue === "checkedA" && !state.start_date_time &&  !state.end_date_time // Only disable if neither date is selected? false : true
                        }
                        // inputProps={{
                        //   min:
                        //     schedulecheckstate.selectedValue === "checkedA" &&
                        //       state.start_date_time
                        //       ? state.start_date_time
                        //       : minDate1,
                        // }}
                        inputProps={{
                          min: state.start_date_time,
                          max: twoMonthsFromStartDate(state.start_date_time),
                        }}
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  {error && (
                  <Alert severity="error" style={{ marginTop: "10px" }}>
                    {error}
                  </Alert>
                )}
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box border={schedulecheckstate.selectedValue === "checkedB" ? 1 : 0}>
              <Accordion
                square
                expanded={schedulecheckstate.selectedValue === "checkedB"}
              >
                <AccordionSummary>
                  <FormControlLabel
                    aria-label="Acknowledge"
                    control={
                      <Checkbox
                        checked={schedulecheckstate.selectedValue === "checkedB"}
                        onChange={handleschedulecheckChange}
                        value="checkedB"
                        color="secondary"
                      />
                    }
                    label={
                      <Typography variant="h5">
                        {" "}
                        During Training Hours{" "}
                        <small>
                          ( Lab will be running at given frequencies between the
                          schedule provided )
                        </small>
                      </Typography>
                    }
                  />
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <Typography variant="h7" gutterBottom>
                        Start Date & Time
                      </Typography>
                      <TextField
                        fullWidth
                        name="start_date_time"
                        id="start_date_time"
                        type="datetime-local"
                        value={state.start_date_time}
                        onChange={handleChange}
                        required
                        variant="outlined"
                        disabled={
                          schedulecheckstate.selectedValue === "checkedB"
                            ? false
                            : true
                        }
                        inputProps={{
                          min: minDate1,
                          max: `${maxDateFinal}T00:00`,
                        }}
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Typography variant="h7" gutterBottom>
                        End Date & Time
                      </Typography>
                      <TextField
                        fullWidth
                        name="end_date_time"
                        id="end_date_time"
                        value={state.end_date_time}
                        type="datetime-local"
                        onChange={handleChange}
                        required
                        variant="outlined"
                        disabled={
                          schedulecheckstate.selectedValue === "checkedB" && !state.start_date_time  //? false : true
                        }
                        inputProps={{
                          min:
                            schedulecheckstate.selectedValue === "checkedB" &&
                              state.start_date_time
                              ? state.start_date_time
                              : minDate1,
                          max: twoMonthsFromStartDate(state.start_date_time),
                        }}
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Box sx={{ pb: 2, pt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Frequency Details
                    </Typography>
                    <Divider />
                  </Box>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={4}>
                      <Typography variant="h8" gutterBottom>
                        Repeat Frequency
                      </Typography>
                      <TextField
                        fullWidth
                        name="repeat_frequency"
                        id="repeat_frequency"
                        onChange={handleChange}
                        value={state.repeat_frequency}
                        disabled={
                          schedulecheckstate.selectedValue === "checkedB"
                            ? false
                            : true
                        }
                        required
                        select
                        SelectProps={{ native: true }}
                        autoComplete="repeat_frequency"
                        InputProps={{
                          style: {
                            height: "40px",
                            width: "340px",
                            marginLeft: "10px",
                          },
                        }}
                      >
                        {" "}
                        <option key="" value=""></option>
                        <option key="day" value="day">
                          Specific Day's
                        </option>
                        <option key="week" value="week">
                          Weekly
                        </option>
                      </TextField>
                    </Grid>
                  </Grid>
                  {schedulecheckstate.selectedValue === "checkedB" && temporary.repeat_frequency === "day" && state.end_date_time ? (
                    <Grid item md={6} xs={4}>
                      <Typography variant="h8" style={{ marginTop: "10px" }} gutterBottom>
                        Choose the Required Dates
                      </Typography>
                      <CustomDaypicker
                        setFrequencyDay={setFrequencyDay}
                        setFrequencyMonth={setFrequencyMonth}
                        startDate={new Date(state.start_date_time).toISOString()}
                        endDate={new Date(state.end_date_time).toISOString()}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {temporary.repeat_frequency === "week" ? (
                    <Grid item md={6} xs={4}>
                      <Typography variant="h8" style={{ marginTop: "10px" }} gutterBottom>
                        On Days
                      </Typography>
                      <Autocomplete
                        multiple
                        name="on_days"
                        size="small"
                        limitTags={2}
                        options={getAvailableDays(state.start_date_time, state.end_date_time)}
                        style={{ width: "340px", marginLeft: "10px" }}
                        onChange={handleChange1}
                        disabled={
                          schedulecheckstate.selectedValue === "checkedB"
                            ? false
                            : true
                        }
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                          <React.Fragment>
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="On Days"
                            />
                          </React.Fragment>
                        )}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {error && (
                  <Alert severity="error" style={{ marginTop: "10px" }}>
                    {error}
                  </Alert>
                )}
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box
              borderColor="error.main"
              border={schedulecheckstate.selectedValue === "checkedC" ? 1 : 0}
            >
              <Accordion
                square
                expanded={schedulecheckstate.selectedValue === "checkedC"}
              >
                <AccordionSummary>
                  <FormControlLabel
                    aria-label="Acknowledge"
                    control={
                      <Checkbox
                        checked={schedulecheckstate.selectedValue === "checkedC"}
                        onChange={handleschedulecheckChange}
                        value="checkedC"
                        color="secondary"
                      />
                    }
                    label={
                      <Typography variant="h5">
                        {" "}
                        Immediate{" "}
                        <small>( Lab will be running upto end date )</small>
                      </Typography>
                    }
                  />
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <Typography variant="h7" gutterBottom>
                        End Date & Time
                      </Typography>
                      <TextField
                        fullWidth
                        name="end_date_time"
                        id="end_date_time"
                        value={state.end_date_time}
                        type="datetime-local"
                        onChange={handleChange}
                        required
                        variant="outlined"
                        disabled={
                          schedulecheckstate.selectedValue === "checkedC"
                            ? false
                            : true
                        }
                        inputProps={{
                          min: minDate1,
                          max: twoMonthsFromCurrentDate(),
                        }}
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  {error && (
                  <Alert severity="error" style={{ marginTop: "10px" }}>
                    {error}
                  </Alert>
                )}
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box sx={{ pt: 2 }}>
              <Typography variant="h6" gutterBottom>
                Billing Type
              </Typography>
            </Box>
            <Box
              borderColor="error.main"
              border={checkDeploystate.selectedDeployValue === "checkedA" ? 1 : 0}
            >
              <Accordion square expanded={checkDeploystate.selectedDeployValue === "checkedA"}>
                <AccordionSummary>
                  <FormControlLabel
                    aria-label="Acknowledge"
                    control={
                      <Checkbox
                        checked={checkDeploystate.selectedDeployValue === "checkedA"}
                        onChange={handlecheckDeployChange}
                        value="checkedA"
                        color="secondary"
                      />
                    }
                    label={
                      <Typography variant="h5">
                        {" "}
                        Budget Based{" "}
                      </Typography>
                    }
                  />
                </AccordionSummary>
              </Accordion>
            </Box>
            <Box
              borderColor="error.main"
              border={checkDeploystate.selectedDeployValue === "checkedB" ? 1 : 0}
            >
              <Accordion square expanded={checkDeploystate.selectedDeployValue === "checkedB"}>
                <AccordionSummary>
                  <FormControlLabel
                    aria-label="Acknowledge"
                    control={
                      <Checkbox
                        checked={checkDeploystate.selectedDeployValue === "checkedB"}
                        onChange={handlecheckDeployChange}
                        value="checkedB"
                        color="secondary"
                      />
                    }
                    label={
                      <Typography variant="h5">
                        {" "}
                        Hourly Based{" "}
                      </Typography>
                    }
                  />
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                      <Typography variant="h7" gutterBottom>
                        Hours<small style={{ paddingLeft: "10px" }}>required</small>
                        <small style={{ color: "red" }}>*</small>
                      </Typography>
                      <TextField
                        fullWidth
                        name="budgethours"
                        id="budgethours"
                        type="number"
                        required
                        autoComplete="budgethours"
                        value={budgethours}
                        onChange={handleHourlybasedChange}
                        disabled={!state.end_date_time} // Disable if dates are not selected
                        inputProps={{
                          inputMode: "numeric", // Helps on mobile devices to show numeric keyboard
                          min: 0,
                          max: total_hours,
                          step: "1",
                          pattern: "[0-9]*", // Ensures only numbers are allowed
                        }}
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                        error={!!scheduleError}
                        helperText={scheduleError}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h8">
                      <strong>Note:</strong>
                      <small>
                        {" "}
                        Please select the Start time and Stop time which includes the idle hours.
                      </small>
                    </Typography>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Box>
            {checkDeploystate.selectedDeployValue !== "checkedB" && (
              <>
                <Box sx={{ pb: 2, pt: 4 }}>
                  <Typography variant="h6" gutterBottom>
                    Budget
                  </Typography>
                  <Divider />
                </Box>
                <Grid item xs={12} sx={{ pt: 2, pb: 2 }}>
                  <Typography variant="h8">
                    Please specify the budget (In Credits) for your lab. if your
                    budget is reached, your lab will be automatically stopped. And the
                    next day it will be terminated.
                  </Typography>
                  <Grid item md={12} xs={12}>
                    <TextField
                      fullWidth
                      // helperText="NOTE: Enter your Budget in Credits"
                      color={state.budget ? "success" : "error"}
                      name="budget"
                      id="budget"
                      value={state.budget}
                      onChange={handleBudgetChange}
                      required
                      placeholder={budget}
                      //error
                      type="number"
                      // variant="outlined"
                      inputProps={{ min: "1", step: "1" }}
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                    ></TextField>
                    <Typography variant="h5">
                      <small>
                        Note: Enter your Budget in Credits. The account will be terminated if the budget is exhausted.
                      </small>
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Box sx={{ pb: 2 }} style={{ marginBottom: '-30px' }}>
                <Typography variant="h6" gutterBottom>
                  {" "}
                  Notification{" "}
                </Typography>
              </Box>
              <Grid item xs={12} style={{ marginTop: "-18px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkstate.checkedB}
                      onChange={handlecheckChange}
                      name="checkedB"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h6"> Receive Labs Details Alerts </Typography>
                  }
                />
              </Grid>
              <Typography variant="h8">
                Lab start/stop notifications are sent to the lab creator by default. To include additional users, provide their email addresses below.
              </Typography>
              <Grid item xs={12} sx={{ pt: 2, marginTop: '-10px' }} >
                <Grid item md={6} xs={12}>
                  <Typography variant="h6"> Email Address: </Typography>
                  <TextField
                    fullWidth
                    name="email"
                    id="email"
                    onChange={handleMailChange}
                    required
                    type="email"
                    placeholder={localStorage.getItem("email")}
                    {...a11yProps(checkstate.checkedB)}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                    error={!!emailError}
                    helperText={emailError}
                  ></TextField>
                </Grid>
                <Typography variant="h5">
                  <small>
                    Note: Provide the email addresses in comma-separated format
                  </small>
                </Typography>
              </Grid>
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Box sx={{ pb: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    {" "}
                    Link Lab{" "}
                  </Typography>
              </Box>
              <Grid item xs={12} style={{ marginTop: "-25px" }}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handlecheckRelatedLabChange}
                        name="guacmoleLabState"
                        color="secondary"
                        checked={temporary.guacmoleLabState || false} // Ensure correct checked state
                      />
                    }
                    label={<Typography variant="h6"> Link this lab with existing lab </Typography>}
                  />
                </Grid>
              </Grid>
              {temporary.guacmoleLabState && (
                <Box sx={{ pb: 2, border: '1px solid #000', borderRadius: '5px', padding: '10px' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Select Lab Type"
                        name="selectedRelatedLabType"
                        id="selectedRelatedLabType"
                        value={selectedRelatedLabType}
                        onChange={handleLabTypeChange}
                        required
                        select
                      >
                        {labtypeoptionslist.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.value}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Select Lab Name"
                        name="selectedMasterLabId"
                        id="selectedMasterLabId"
                        value={selectedMasterLabId || ''} // Ensure it's always a valid string
                        onChange={handleMasterLabNameChange}
                        select
                        required
                      >
                        {otherlablist.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Box sx={{ pb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  {" "}
                  Manage Labs{" "}
                </Typography>
              </Box>
              <Grid item xs={12} style={{ marginTop: "-25px" }}>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handlecheckManageLabChange}
                        name="manage_lab"
                        color="secondary"
                        disabled={schedulecheckstate.selectedValue !== 'checkedB'}
                      />
                    }
                    label={<Typography variant="h6" style={{ whiteSpace: 'nowrap' }} > During Training Hours </Typography>}
                  />
                </Grid>
              </Grid>
              <Typography variant="h8">
                Allow users to start/stop lab servers beyond training hours.
              </Typography>
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Box sx={{ pb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  {" "}
                  Feedback{" "}
                </Typography>
              </Box>
              <Grid item xs={12} style={{ marginTop: "-30px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={feedbackState.feedbackCheckbox}
                      onChange={handlecheckFeedbackChange}
                      name="feedbackCheckbox"
                      color="secondary"
                    />
                  }
                  label={
                    <Typography variant="h6" style={{ whiteSpace: 'nowrap' }}> Check the box and select the dates if trainees are required to submit feedback. </Typography>
                  }
                />
              </Grid>
              <Grid item xs={12} >
                <Grid item md={6} xs={12}>
                  <Box marginTop={0}>
                    <Typography variant="h6" style={{ whiteSpace: 'nowrap' }}> Choose the dates for submitting feedback
                      <DatePicker
                        multiple
                        id="selectedDates"
                        style={{ marginRight: "10px" }}
                        render={<CustomMultipleInput />}
                        onChange={handleDateChange}
                        {...a11yProps(feedbackState.feedbackCheckbox)}
                        value={selectedDates.map((d) => new Date(d.split("/").reverse().join("-")))}
                        minDate={state.start_date_time}
                        maxDate={state.end_date_time}
                      />
                    </Typography>
                    {selectedDates.length > 0 && (
                      <Typography style={{ marginTop: "10px" }} variant="body1">
                        <Typography variant="h6" component="span">Selected Dates:</Typography>{" "}
                        {selectedDates.join(", ")}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Box sx={{ pb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  {" "}
                  Keep Lab Environment{" "}
                </Typography>
              </Box>
              <Grid item xs={12} style={{ marginTop: "-25px" }}>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handlecheckBudgetChange}
                        name="env_keep"
                        color="secondary"
                      />
                    }
                    label={<Typography variant="h6" style={{ whiteSpace: 'nowrap' }}> Retain the lab environment </Typography>}
                  />
                </Grid>
                {temporary.env_keep ? (
                  <Grid item md={3} xs={3}>
                    <TextField
                      fullWidth
                      name="env_keep_date"
                      id="env_keep_date"
                      type="date"
                      onChange={handleKeepLabChange}
                      required
                      variant="outlined"
                      InputProps={{
                        style: {
                          height: "40px",
                        },
                      }}
                      inputProps={{
                        min: state.end_date_time,
                        max: getTenDaysAfterEndDate(state.end_date_time),
                      }}
                    />
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
              <Typography variant="h8">
                Enable and select dates to retain the lab environment if the lab is required beyond the stop date or if the lab budget exceeded.
              </Typography>
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Box sx={{ pb: 2 }}>
                <Typography variant="h6" gutterBottom>
                  {" "}
                  Meeting Link{" "}
                </Typography>
              </Box>
              <Typography variant="h8">
                Please share the meeting link
              </Typography>
              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  name="meetingLink"
                  id="meetingLink"
                  onChange={handleMeetingLinkChange}
                  required
                  type="text"
                  variant="outlined"
                  InputProps={{
                    style: {
                      height: "40px",
                    },
                  }}
                ></TextField>
              </Grid>
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Grid item xs={12} style={{ marginTop: "-25px" }}>
                <Grid item md={12} xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handlecheckBudgetChange}
                        name="disable_copypaste"
                        color="secondary"
                      />
                    }
                    label={<Typography variant="h6"> Disable copy paste for instance lab </Typography>}
                  />
                </Grid>
              </Grid>
            </Box>
            <Divider style={{ marginBottom: "20px" }} />
            <Box sx={{ pb: 2, border: '1px #000', borderRadius: '5px', padding: '10px' }}>
              <Grid item xs={12} style={{ marginTop: "-25px" }}>
                <Grid item md={12} xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handlecheckBudgetChange}
                        name="identicalpassword"
                        color="secondary"
                      />
                    }
                    label={<Typography variant="h6">Set identical password on all servers</Typography>}
                  />
                </Grid>
              </Grid>
            </Box>
          </LoadingOverlay>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button onClick={handleClickClose} color="primary" variant="contained" sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }} aria-label="Cancel">
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Save" arrow>
            <span>
          <Button
            onClick={handleSubmitClick(InstanceID)}
            color="primary"
            variant="contained"
            sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }}
            //   disabled={
            //     state.number_of_trainee >= 4 && state.budget && state.name
            //       ? false
            //       : true
            //   }
            // >
            disabled={
              (schedulecheckstate.selectedValue === "checkedA" &&
                state.start_date_time &&
                state.end_date_time
                ? false
                : schedulecheckstate.selectedValue === "checkedB" &&
                  state.start_date_time &&
                  state.end_date_time &&
                  (state.repeat_frequency || state.on_days)
                  ? false
                  : schedulecheckstate.selectedValue === "checkedC" &&
                    state.end_date_time && !numberfind
                    ? false
                    : true) ||
              (feedbackState.feedbackCheckbox && selectedDates.length === 0) ||
              (checkstate.checkedB && !temporary.email) ||
              (bothChecked && (!temporary.email || selectedDates.length === 0) ||
                (temporary.env_keep && keepLabDate.length === 0)) || showAlert || numberfind || find ||
              !((checkDeploystate.selectedDeployValue === "checkedA" &&
                state.budget) || (checkDeploystate.selectedDeployValue === "checkedB" &&
                  budgethours)) ||
              scheduleError || (temporary.guacmoleLabState && (!selectedRelatedLabType || !selectedMasterLabId))

            }>
            Save
          </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );

}
